export const MainMarketData = [   
    1, // "1x2"
    11,  // "Draw no bet"
    610, // "1x2 (incl. overtime)"
    612, // "Draw no bet (incl. overtime)"
    186, // "Winner"
    219,  // "Winner (incl. overtime)"
    251, // "Winner (incl. extra innings)"
    340, // "Winner (incl. super over)"
    406, // "Winner (incl. overtime and penalties)"

    16, // "Handicap"
    14, // "Handicap {hcp}"
    117, // "Overtime - handicap"
    165, // "Corner handicap"
    187, // "Game handicap"
    223, // "Handicap (incl. overtime)"
    237, // "Point handicap"
    246, // "{!gamenr} game - point handicap"
    408, // "Handicap {hcp} (incl. overtime and penalties)"
    410, // "Handicap (incl. overtime and penalties)"
    327, // ""
    331, // ""


    2, // "To qualify"
    3, // "Which team will win the final"
    4, // "Which team will win the 3rd place final"
    5, // "Winning method"
    6, // "Which team kicks off"
    7, // "Which team wins the rest of the match"
    8, // "1st goal"
    9, // "Last goal"
    10, // "Double chance"
    
    12, // "Home Team no bet"
    13, // "Away Team no bet"
    
    15, // "Winning margin"

    18, // "Total"
    19, // "Home Team total"
    20, // "Away Team total"
    21, // "Exact goals"
    23, // "Home Team exact exact goals"
    24, // "Away Team exact goals"
    25, // "Goal range"
    26, // "Odd/even"
    27, // "Home Team odd/even"
    28, // "Away Team odd/even"
    29, // "Both teams to score"
    30, // "Which team to score"
    31, // "Home Team clean sheet"
    32, // "Away Team clean sheet"
    33, // "Home Team win to nil"
    34, // "Away Team win to nil"
    35, // "1x2 & both teams to score"
    36, // "Total & both teams to score"
    37, // "1x2 & total"
    38, // "{!goalnr} goalscorer"
    39, // "Last goalscorer"
    40, // "Anytime goalscorer"
    



    
    100, // "When will the {!goalnr} goal be scored (15 min interval)"
    101, // "When will the {!goalnr} goal be scored (10 min interval)"
    102, // "15 minutes - 1x2 from {from} to {to}"
    103, // "15 minutes - {!goalnr} goal from {from} to {to}"
    104, // "15 minutes - total from {from} to {to}"
    105, // "10 minutes - 1x2 from {from} to {to}"
    106, // "10 minutes - {!goalnr} goal from {from} to {to}"
    107, // "10 minutes - total from {from} to {to}"
    108, // "5 minutes - 1x2 from {from} to {to}"
    109, // "5 minutes - {!goalnr} goal from {from} to {to}"
    110, // "5 minutes - total from {from} to {to}"
    112, // "Overtime & goal"
    113, // "Overtime - 1x2"
    114, // "Overtime - which team wins the rest"
    115, // "Overtime - {!goalnr} goal"
    116, // "Overtime - total"




    122, // "Will there be a penalty shootout"
    123, // "Penalty shootout - winner"
    124, // "Penalty shootout - {!penaltynr} penalty scored"
    125, // "Penalty shootout - {!goalnr} goal"
    126, // "Penalty shootout - winning margin"
    127, // "Penalty shootout - total"
    128, // "Penalty shootout - Home Team total"
    129, // "Penalty shootout - Away Team total"
    130, // "Penalty shootout - exact goals"
    131, // "Penalty shootout - odd/even"
    132, // "Penalty shootout - Home Team odd/even"
    133, // "Penalty shootout - Away Team odd/even"
    134, // "Penalty shootout - winner & total"

    136, // "Booking 1x2"
    137, // "{!bookingnr} booking"
    138, // "Total booking points"
    139, // "Total bookings"
    140, // "Home Team total bookings"
    141, // "Away Team total bookings"
    142, // "Exact bookings"
    143, // "Home Team exact bookings"
    144, // "Away Team exact bookings"
    145, // "Booking point range"
    146, // "Sending off"
    147, // "Home Team sending off"
    148, // "Away Team sending off"
    


    162, // "Corner 1x2"
    163, // "{!cornernr} corner"
    164, // "Last corner"

    166, // "Total corners"
    167, // "Home Team total corners"
    168, // "Away Team total corners"
    169, // "Corner range"
    170, // "Home Team corner range"
    171, // "Away Team corner range"
    172, // "Odd/even corners"
    

    184, // "{!goalnr} goal & 1x2"
    

    189, // "Total games"
    190, // "Home Team total games"
    191, // "Away Team total games"

    195, // "Will there be a tiebreak"

    198, // "Odd/even games"


    209, // "{!gamenrY}게임 승패"
    

    220, // "Will there be overtime"

    224, // "US spread (incl. overtime)"
    225, // "Total (incl. overtime)"
    226, // "US total (incl. overtime)"
    227, // "Home Team total (incl. overtime)"
    228, // "Away Team total (incl. overtime)"
    229, // "Odd/even (incl. overtime)"
    230, // "Race to {pointnr} points (incl. overtime)"

    

    238, // "Total points"
    239, // "How many games will be decided by extra points"
    241, // "Exact games"

    245, // "{!gamenr} game - winner"

    248, // "{!gamenr} game - odd/even"
    250, // "{!gamenr} game - race to {pointnr} points"
    
    253, // "Which team wins the rest of the match (incl. extra innings)"

    254, // "Handicap {hcp} (incl. extra innings)"
    255, // "Winning margin (incl. extra innings)"
    256, // "Handicap (incl. extra innings)"

    257, // "US Spread (incl. extra innings)"
    258, // "Total (incl. extra innings)"
    259, // "US Total (incl. extra innings)"
    260, // "Home Team total (incl. extra innings)"
    261, // "Away Team total (incl. extra innings)"
    262, // "Total (over-exact-under) (incl. extra innings)"
    263, // "Run range (incl. extra innings)"
    264, // "Odd/even (incl. extra innings)"
    265, // "1x2 & total (incl. extra innings)"
    266, // "{!runnr} run (incl. extra innings)"
    267, // "Race to {runnr} runs (incl. extra innings)"


    274, // "Innings 1 to 5 - 1x2"
    275, // "Innings 1 to 5 - handicap"
    276, // "Innings 1 to 5 - total"
    277, // "Innings 1 to 5 - Home Team total"
    278, // "Innings 1 to 5 - Away Team total"
    279, // "Innings 1 to 5th top - 1x2"
    280, // "Innings 1 to 5th top - handicap"
    281, // "Innings 1 to 5th top - total"
    282, // "Innings 1 to 5th top - Home Team total"
    283, // "Innings 1 to 5th top - Away Team total"
    284, // "Innings {from} to {to} - total"
    285, // "Innings {from} to {to} - Home Team total"
    286, // "Innings {from} to {to} - Away Team total"


    289, // "Which team wins the jump ball"
    290, // "Winning margin (incl. overtime)"
    291, // "{!pointnr} point (incl. overtime)"
    292, // "Winner & total (incl. overtime)"
    

    297, // "Total (over-exact-under)"
    298, // "Point range"
    300, // "Race to {pointnr} points"


    
    341, // "Will there be a super over"
    342, // "Will there be a tie"
    343, // "{!inningnr} innings - {!dismissalnr} dismissal method"
    344, // "{!inningnr} innings - {!dismissalnr} dismissal method (limited)"
    345, // "{!inningnr} innings - Home Team run range"
    346, // "{!inningnr} innings - Away Team run range"
    347, // "{!inningnr} innings - team with highest scoring over"
    348, // "{!inningnr} innings - run range in the highest scoring over"
    349, // "{!inningnr} innings - Home Team total at {!dismissalnr} dismissal"
    350, // "{!inningnr} innings - Away Team total at {!dismissalnr} dismissal"
    351, // "{!inningnr} innings overs 0 to {overnr} - 1x2"
    352, // "{!inningnr} innings overs 0 to {overnr} - Home Team total"
    353, // "{!inningnr} innings overs 0 to {overnr} - Away Team total"
    354, // "{!inningnr} innings overs 0 to {overnr} - Home Team run range"
    355, // "{!inningnr} innings overs 0 to {overnr} - Away Team run range"
    356, // "{!inningnr} innings over {overnr} - Home Team total"
    357, // "{!inningnr} innings over {overnr} - Away Team total"
    358, // "1st over - total"
    359, // "{!inningnr} innings over {overnr} - Home Team odd/even"
    360, // "{!inningnr} innings over {overnr} - Away Team odd/even"
    361, // "1st over - odd/even"
    362, // "{!inningnr} innings over {overnr} - {!deliverynr} delivery Home Team total"
    363, // "{!inningnr} innings over {overnr} - {!deliverynr} delivery Away Team total"
    
    407, // "{!goalnr} goal (incl. overtime and penalties)"

    409, // "Winning margin (incl. overtime and penalties)"

    411, // "US spread (incl. overtime and penalties)"
    412, // "Total (incl. overtime and penalties)"
    413, // "US total (incl. overtime and penalties)"
    414, // "Home Team total (incl. overtime and penalties)"
    415, // "Away Team total (incl. overtime and penalties)"
    416, // "Exact goals (incl. overtime and penalties)"
    417, // "Home Team exact goals (incl. overtime and penalties)"
    418, // "Away Team exact goals (incl. overtime and penalties)"
    419, // "Odd/even (incl. overtime and penalties)"
    420, // "Which team to score (incl. overtime and penalties)"
    421, // "Home Team clean sheet (incl. overtime and penalties)"
    422, // "Away Team clean sheet (incl. overtime and penalties)"
    423, // "{!goalnr} goal & winner (incl. overtime and penalties)"
    424, // "1x2 & total (incl. overtime and penalties)"
    425, // "1x2 & both teams to score (incl. overtime and penalties)"


    463, // "Overtime - double chance"
    464, // "Overtime - draw no bet"
    465, // "Overtime - Home Team no bet"
    466, // "Overtime - Away Team no bet"
    

    520, // "{!gamenr} game - {!pointnr} point"
    


    546, // "Double chance & both teams to score"
    547, // "Double chance & total"
    548, // "Multigoals"
    549, // "Home Team multigoals"
    550, // "Away Team multigoals"
    551, // "Multiscores"
    

    563, // "Race to {pointnr} points"
    565, // "15 minutes - corner 1x2 from {from} to {to}"
    566, // "15 minutes - {!cornernr} corner from {from} to {to}"
    567, // "15 minutes - corner handicap from {from} to {to}"
    568, // "15 minutes - total corners from {from} to {to}"
    569, // "15 minutes - Home Team total corners from {from} to {to}"
    570, // "15 minutes - Away Team total corners from {from} to {to}"
    571, // "15 minutes - odd/even corners from {from} to {to}"
    572, // "10 minutes - corner 1x2 from {from} to {to}"
    573, // "10 minutes - {!cornernr} corner from {from} to {to}"
    574, // // "10 minutes - corner handicap from {from} to {to}"
    575, // // "10 minutes - total corners from {from} to {to}"
    576, // // "10 minutes - Home Team total corners from {from} to {to}"
    577, // // "10 minutes - Away Team total corners from {from} to {to}"
    578, // "10 minutes - odd/even corners from {from} to {to}"
    579, // "5 minutes - corner 1x2 from {from} to {to}"
    580, // "5 minutes - {!cornernr} corner from {from} to {to}"
    581, // "5 minutes - corner handicap from {from} to {to}"
    582, // "5 minutes - total corners from {from} to {to}"
    583, // "5 minutes - Home Team total corners from {from} to {to}"
    584, // "5 minutes - Away Team total corners from {from} to {to}"
    585, // "5 minutes - odd/even corners from {from} to {to}"
    586, // "15 minutes - booking 1x2 from {from} to {to}"
    587, // "15 minutes - total bookings from {from} to {to}"
    588, // "15 minutes - sending off from {from} to {to}"
    589, // "15 minutes - Home Team sending off from {from} to {to}"
    590, // "15 minutes - Away Team sending off from {from} to {to}"
    591, // "10 minutes - booking 1x2 from {from} to {to}"
    592, // "10 minutes - total bookings from {from} to {to}"
    593, // "10 minutes - sending off from {from} to {to}"
    594, // "10 minutes - Home Team sending off from {from} to {to}"
    595, // "10 minutes - Away Team sending off from {from} to {to}"
    596, // "5 minutes - booking 1x2 from {from} to {to}"
    597, // "5 minutes - total bookings from {from} to {to}"
    598, // "5 minutes - sending off from {from} to {to}"
    599, // "5 minutes - Home Team sending off from {from} to {to}"
    600, // "5 minutes - Away Team sending off from {from} to {to}"
    601, // "Race to {cornernr} corners"


    603, // "{!goalnr} goal - strike zone"
    604, // "{!penaltynr} penalty scored"
    605, // "{!inningnr} innings - total"
    606, // "{!inningnr} innings - Home Team total"
    607, // "{!inningnr} innings - Away Team total"
    608, // "{!inningnr} innings - odd/even"


    616, // "Home Team odd/even (incl. overtime)"
    617, // "Away Team odd/even (incl. overtime)"
    

    638, // "{!inningnr} innings - {%player} total"
    639, // "Total fours"
    640, // "Total sixes"
    641, // "{!inningnr} innings over {overnr} - Home Team dismissal"
    642, // "{!inningnr} innings over {overnr} - Away Team dismissal"
    643, // "{!inningnr} innings - {%player} total fours"
    644, // "{!inningnr} innings - {%player} total sixes"
    645, // "{!inningnr} innings over {overnr} - 1x2"
    646, // "Team with highest score at {!dismissalnr} dismissal"
    647, // "Most fours"
    648, // "Most sixes"
    649, // "{!inningnr} innings - Home Team total dismissals"
    650, // "{!inningnr} innings - Away Team total dismissals"
    651, // "{!inningnr} innings - {%player} dismissal method"
    652, // "{!inningnr} innings over {overnr} - Home Team boundary"
    653, // "{!inningnr} innings over {overnr} - Away Team boundary"
    654, // "Total run outs"
    655, // "Total extras"
    656, // "{!inningnr} innings - {!dismissalnr} partnership 1x2"
    657, // "{!inningnr} innings - {!dismissalnr} batter out"
    658, // "{!inningnr} innings - Home Team total fours"
    659, // "{!inningnr} innings - Away Team total fours"
    660, // "{!inningnr} innings - Home Team total sixes"
    661, // "{!inningnr} innings - Away Team total sixes"
    662, // "{!inningnr} innings - {%player} to score {milestone}"
    663, // "{!inningnr} innings overs 0 to {overnr} - Home Team total dismissals"
    664, // "{!inningnr} innings overs 0 to {overnr} - Away Team total dismissals"
    665, // "{!daynr} day session {sessionnr} - total"
    666, // "{!inningnr} innings - Home Team total extras"
    667, // "{!inningnr} innings - Away Team total extras"
    668, // "{!inningnr} innings - Home Team total run outs"
    669, // "{!inningnr} innings - Away Team total run outs"
    670, // "{!inningnr} innings - Home Team total in the highest scoring over"
    671, // "{!inningnr} innings - Away Team total in the highest scoring over"
    672, // "{!inningnr} innings - Home Team exact runs"
    673, // "{!inningnr} innings - Away Team exact runs"
    674, // "{!inningnr} innings - Home Team top batter"
    675, // "{!inningnr} innings - Away Team top batter"
    676, // "{!inningnr} innings - Home Team top bowler"
    677, // "{!inningnr} innings - Away Team top bowler"
    678, // "{!inningnr} innings - Home Team last player standing"
    679, // "{!inningnr} innings - Away Team last player standing"
    680, // "Most extras"
    681, // "Most run outs"
    682, // "Total in the highest scoring over"
    683, // "Top batter"
    684, // "Top bowler"
    685, // "Player of the match"
    686, // "Batter head2head (1x2)"
    687, // "Bowler head2head (1x2)"
    688, // "All-rounder head2head (1x2)"
    689, // "Keeper head2head (1x2)"
    690, // "{!inningnr} innings - Home Team odd/even"
    691, // "{!inningnr} innings - Away Team odd/even"
    692, // "{!inningnr} innings - Home Team to finish with a boundary"
    693, // "{!inningnr} innings - Away Team to finish with a boundary"
    694, // "Which team wins the coin toss"
    695, // "Total ducks"
    696, // "Total wides"
    697, // "Total dismissals"
    698, // "Team with top batter"
    699, // "Team with top bowler"
    700, // "{!inningnr} innings - any player to score {milestone}"
    701, // "Any player to score {milestone}"
    702, // "Top batter total"
    703, // "Rabbit total"
    704, // "{!inningnr} innings - Home Team total wides bowled"
    705, // "{!inningnr} innings - Away Team total wides bowled"
    706, // "{!inningnr} innings - Home Team total ducks"
    707, // "{!inningnr} innings - Away Team total ducks"
    708, // "{!inningnr} innings - {%player} total dismissals"
    709, // "{%player} total player performance"
    710, // "Which team wins the coin toss and the match"
    711, // "{!inningnr} innings - 1x2"
    712, // "Most keeper catches"
    713, // "Most catches"
    714, // "Most stumpings"
    715, // "{!inningnr} innings over {overnr} - Home Team run range"
    716, // "{!inningnr} innings over {overnr} - Away Team run range"
    717, // "Batter head2head (handicap)"
    718, // "{!inningnr} innings - {!dismissalnr} dismissal method (extended)"
    719, // "Player Saves (incl. overtime)"


    737, // "Maximum consecutive runs by either team"
    738, // "When will the match be decided"
    739, // "When will the {!runnr} run be scored (incl. extra innings)"
    740, // "Total scoreless innings"
    741, // "Both teams over {total} (incl. extra innings)"
    742, // "First {innings} innings 1x2 & 1x2 (incl. extra innings)"
    743, // "Innings {from} to {to} - 1x2"
    744, // "Innings {from} to {to} - handicap"
    745, // "Innings {from} to {to} - odd/even"


    759, // "Player passing yards (incl. overtime)"
    760, // "Player pass completions"
    761, // "Player passing touchdowns"
    762, // "Player carries"
    764, // "Player rushing yards (incl. overtime)"
    765, // "Player receiving yards (incl. overtime)"
    767, // "Player receptions (incl. overtime)"
    768, // "Player points (incl. overtime)"
    770, // "Player assists"
    771, // "Player blocks"
    772, // "Player rebounds (incl. overtime)"
    773, // "Player steals (incl. overtime)"
    774, // "Player 3-point field goals"
    775, // "Player goals"
    776, // "Player shots"
    777, // "Player shots on goal"
    778, // "Player passes (incl. overtime)"
    780, // "Player tackles (incl. overtime)"
    781, // "Batter hits (incl. extra innings)"
    782, // "Batter home runs"
    785, // "Pitcher strikeouts (incl. extra innings)"
    787, // "Batter total bases (incl. extra innings)"
    788, // "Batter runs + runs batted in (incl. extra innings)"
    797, // "{$event} matchday {matchday} - home teams total"
    798, // "{$event} matchday {matchday} - away teams total"
    799, // "{$event} matchday {matchday} - total"
    800, // "{$event} matchday {matchday} - most goals home or away teams"
    801, // "{$event} matchday {matchday} - total home team wins"
    802, // "{$event} matchday {matchday} - total draws"
    803, // "{$event} matchday {matchday} - total away team wins"
    804, // "{$event} - winner"
    805, // "{$event} - top {pos} finish"
    806, // "{$event} - bottom {pos} finish"
    807, // "{$event} - head2head"
    808, // "{$event} group {group} - group winner"
    809, // "{$event} - qualify to play offs"
    810, // "{$event} group {group} - top {pos} exact order"
    812, // "{$event} - to reach the final"
    816, // "{!inningnr} innings - Home Team {!dismissalnr} dismissal method (extended)"
    817, // "{!inningnr} innings - Away Team {!dismissalnr} dismissal method (extended)"
    

    835, // "Home Team windex"
    836, // "Away Team windex"
    837, // "Home Team/Away Team supremacy"
    838, // "Away Team/Home Team supremacy"
    839, // "{!inningnr} innings - Home Team total spread"
    840, // "{!inningnr} innings - Away Team total spread"
    841, // "{!inningnr} innings - Home Team total spread at {!dismissalnr} dismissal"
    842, // "{!inningnr} innings - Away Team total spread at {!dismissalnr} dismissal"
    843, // "{!inningnr} innings - {%player} total spread"
    844, // "{!inningnr} innings overs 0 to {overnr} - Home Team total spread"
    845, // "{!inningnr} innings overs 0 to {overnr} - Away Team total spread"
    846, // "{!inningnr} innings over {overnr} - Home Team total spread"
    847, // "{!inningnr} innings over {overnr} - Away Team total spread"
    848, // "{$event} - top {pos} exact order"
    849, // "Any team winning margin (incl. overtime)"

    854, // "Home Team or over {total}"
    855, // "Home Team or under {total}"
    856, // "Draw or over {total}"
    857, // "Draw or under {total}"
    858, // "Away Team or over {total}"
    859, // "Away Team or under {total}"
    860, // "Home Team or both teams to score"
    861, // "Draw or both teams to score"
    862, // "Away Team or both teams to score"
    863, // "Home Team or any clean sheet"
    864, // "Draw or any clean sheet"
    865, // "Away Team or any clean sheet"
    875, // "{!inningnr} innings - Home Team total at {!dismissalnr} dismissal"
    876, // "{!inningnr} innings - Away Team total at {!dismissalnr} dismissal"
    877, // "{!inningnr} innings - Home Team total"
    878, // "{!inningnr} innings - Away Team total"
    879, // "Away Team to win"
    880, // "Home Team to win"
    881, // "Any team to win"
    

    882, // "{%player} to score (incl. overtime)"
    883, // "1 minute - total from {from} to {to}"
    884, // "1 minute - total corners from {from} to {to}"
    885, // "1 minute - total bookings from {from} to {to}"
    886, // "1 minute - total offsides from {from} to {to}"
    887, // "1 minute - total penalties awarded from {from} to {to}"
    888, // "Anytime goalscorer & 1x2"

    891, // "{!goalnr} goalscorer & 1x2"
    892, // "{!goalnr} goalscorer"
    893, // "Last goalscorer"

    896, // "{!scorenr} scoring type"

    898, // "Player to score 2+"
    899, // "Player to score 3+"
    900, // "Home Team {!c1goalnr} goalscorer"
    901, // "Away Team {!c2goalnr} goalscorer"
    903, // "Next score (incl. overtime)"
    904, // "Next scoring type (incl. overtime)"
    

    909, // "{!touchdownnr} touchdown scorer (incl. overtime)"
    914, // "{%player} total passing yards"
    915, // "{%player} total pass completions"
    916, // "{%player} total passing touchdowns"
    917, // "{%player} total carries"
    918, // "{%player} total rushing yards"
    919, // "{%player} total receiving yards"
    920, // "{%player} total receptions (incl. overtime)"

    922, // "{%player} total assists"
    923, // "{%player} total rebounds"
    924, // "{%player} total 3-point field goals"
    925, // "{%player} total pitcher strikeouts"
    926, // "{%player} total bases"
    927, // "{%player} total batter runs + runs batted in (incl. extra innings)"
    929, // "{%player} total saves (incl. overtime)"
    931, // "Total touchdowns (incl. overtime)"
    932, // "Total field goals made (incl. overtime)"
    933, // "Total turnovers (incl. overtime)"
    934, // "Total sacks (incl. overtime)"
    940, // "{!fieldgoalnr} field goal made (incl. overtime)"
    956, // "{!timeoutnr} timeout"
    959, // "{!drivenr} drive - result"

    961, // "{!freethrownr} free throw scored"
    962, // "Home Team total maximum consecutive points"
    963, // "Away Team total maximum consecutive points"
    964, // "Any team total maximum consecutive points"
    965, // "Home Team to lead by {points}"
    966, // "Away Team to lead by {points}"
    967, // "Any team to lead by {points}"
    968, // "Anytime goalscorer"
    969, // "Player to score a point"
    970, // "Total sixes spread"
    971, // "Multi sixes spread"
    972, // "Home Team 10/3 sixes head2head spread"
    973, // "Away Team 10/3 sixes head2head spread"
    974, // "{!inningnr} innings - Home Team total sixes spread"
    975, // "{!inningnr} innings - Away Team total sixes spread"
    976, // "Total fours spread"
    977, // "Multi fours spread"
    978, // "{!inningnr} innings - Home Team total fours spread"
    979, // "{!inningnr} innings - Away Team total fours spread"
    980, // "Home Team joy of six spread"
    981, // "Away Team joy of six spread"
    982, // "Total {upsnr} ups spread"
    984, // "{!inningnr} innings - Home Team total {upsnr} ups spread"
    985, // "{!inningnr} innings - Away Team total {upsnr} ups spread"
    988, // "{!inningnr} innings overs 0 to {overnr} - Home Team supremacy spread"
    989, // "{!inningnr} innings overs 0 to {overnr} - Away Team supremacy spread"
    992, // "Total wides spread"
    993, // "Multi wides spread"
    994, // "{!inningnr} innings {!overnr} over - total runs spread"
    995, // "Multi flyer spread"
    996, // "Total run outs spread"
    997, // "Launch spread"
    998, // "Man of the match player performance spread"
    999, // "{%player} total player performance spread"
    1000, // "{!inningnr} innings overs {overnrX} x {overnrY} - Home Team multi run spread"
    1001, // "{!inningnr} innings overs {overnrX} x {overnrY} - Away Team multi run spread"
    1002, // "{!inningnr} innings - {%player} {upsnr} ups spread"
    1040, // "Total hits (incl. extra innings)"
    1041, // "Home Team total hits (incl. extra innings)"
    1042, // "Away Team total hits (incl. extra innings)"


    1046, // "Innings 1 to 5 - total hits"
    1047, // "Innings 1 to 5 - Home Team total hits"
    1048, // "Innings 1 to 5 - Away Team total hits"
    1049, // "Result of {!pitchnr} pitch"
    1050, // "Hit on {!pitchnr} pitch"
    1051, // "Home run on {!pitchnr} pitch"
    1052, // "Result of {!hitnr} hit"
    1053, // "Result of {%player} {!appearancenr} time at bat"
    1054, // "{%player} to strike out {!appearancenr} time at bat"
    1055, // "Winner & total"

    1058, // "{!scorenr} scoring type"
    1059, // "Home Team {!c1scorenr} scoring type"
    1060, // "Away Team {!c2scorenr} scoring type"
    1061, // "{!drivenr} drive play {playnr} - {%competitor} play type"
    1062, // "{!drivenr} drive play {playnr} - {%competitor} pass completion"
    1063, // "{!drivenr} drive play {playnr} - {%competitor} total yards gained"
    1064, // "{!drivenr} drive play {playnr} - {%competitor} new first down"
    1065, // "{!drivenr} drive play {playnr} - {%competitor} sack"
    1066, // "{!drivenr} drive - {%competitor} result"
    1067, // "Winner & total (incl. extra innings)"
    1068, // "Will there be a grand slam (incl. extra innings)"
    1069, // "Any team win to nil (incl. extra innings)"


    1083, // "Pitch range of {%player} {!appearancenr} time at bat"
    1084, // "Exact strikes of {%player} {!appearancenr} time at bat"
    1085, // "Exact balls of {%player} {!appearancenr} time at bat"
    1086, // "Total speed of {!pitchnr} pitch"
    1087, // "Exact home runs (incl. extra innings)"
    1088, // "Scoring type {!pointnr} point (incl. overtime)"
    1089, // "Any team scoring type {!pointnr} point (incl. overtime)"

    1120, // "Total home runs (incl. extra innings)"
    1121, // "Home Team total home runs (incl. extra innings)"
    1122, // "Away Team total home runs (incl. extra innings)"

    1124, // "Innings 1 to 5 - Winner"
    1125, // "{!inningnr} innings - {%player1} to score {milestone} & {%player2} over {total} dismissals"
    1127, // "{!inningnr} innings - {%player1} to score {milestone1} & {%player2} to score {milestone2}"
    1128, // "{!inningnr} innings - {%player1} & {%player2} to score {milestone} & {%player3} over {total} dismissals"
    1129, // "{!inningnr} innings - {%player1} + {%player2} total"
    1130, // "{!inningnr} innings - {%player1} + {%player2} + {%player3} total"
    1131, // "Both teams to score {milestone}"
    1132, // "{!inningsnr} innings  over {overnr} - deliveries {deliverynr1} & {deliverynr2} Home Team over {total}"
    1133, // "{!inningsnr} innings  over {overnr} - deliveries {deliverynr1} & {deliverynr2} Away Team over {total}"
    1134, // "{!inningnr} innings - {%player1} & {%player2} dismissal method"
    1135, // "Which team has the highest 1st partnership & 1st over & overs 0 to {overnr}"
    1136, // "{!inningnr} innings over {overnr} - {!deliverynr} delivery Home Team exact runs"
    1137, // "{!inningnr} innings over {overnr} - {!deliverynr} delivery Away Team exact runs"
    1138, // "{!inningnr} innings over {overnr} - {!deliverynr} delivery Home Team to be a wicket"
    1139, // "{!inningnr} innings over {overnr} - {!deliverynr} delivery Away Team to be a wicket"
    1140, // "{!inningnr} innings - {%player1} or {%player2} dismissal method"
    1141, // "{!inningnr} innings over {overnr} - {%player1} & {%player2} to hit a boundary"
    1142, // "{!inningnr} innings over {overnr} - {%player1} & {%player2} over {total}"
    1143, // "{!inningnr} innings over {overnr} - Home Team to score a boundary four & a six"
    1144, // "{!inningnr} innings over {overnr} - Away Team to score a boundary four & a six"
    1145, // "{!inningnr} innings - {%player1} or {%player2} to survive a review"
    1146, // "{!inningnr} innings - race to {runs} runs"
    1147, // "{%player} to score {milestone} & take a wicket & a catch"
    1148, // "{!overnr} over - Home Team total ({ballcount}-ball overs)"
    1149, // "{!overnr} over - Away Team total ({ballcount}-ball overs)"
    1150, // "Overs 0 to {overnr} - Home Team total ({ballcount}-ball overs)"
    1151, // "Overs 0 to {overnr} - Away Team total ({ballcount}-ball overs)"
    1152, // "{%player} total rushing touchdowns (incl. overtime)"
    1173, // "Winner (including OT) & Total (including OT)"
    1174, // "Handicap (including OT) & Total (including OT)"

    1183, // "{%player} total shots (incl. overtime)"
    1185, // "{%player} total shots on goal (incl. overtime)"
    1187, // "{%player} total passes (incl. overtime)"
    1189, // "{%player} total tackles (incl. overtime)"
    1191, // "Player to be carded (incl. overtime)"

    1211, // "Match to end {score}"
    1214, // "{!inningnr} innings - {%player} total deliveries faced"
    1215, // "{!inningnr} innings - {%player} runs conceded"
    1216, // "{!inningnr} innings - Home Team most economical bowler"
    1217, // "{!inningnr} innings - Away Team most economical bowler"
    1218, // "{!inningnr} innings - Home Team next boundary {boundary number} off Bat, Four or Six"
    1219, // "{!inningnr} innings - Away Team next boundary {boundary number} off Bat, Four or Six"
    1220, // "Total batsman milestones (50s/100s)"
    1221, // "{!inningnr} innings - Home Team  {!dismissalnr} dismissal method (limited)"
    1222, // "{!inningnr} innings - Away Team  {!dismissalnr} dismissal method (limited)"
    1223, // "{!inningnr} innings over {overnr} - Home Team run range"
    1224, // "{!inningnr} innings over {overnr} - Away Team run range"
    1225, // "{!inningnr} innings - Home Team run range"
    1226, // "{!inningnr} innings - Away Team run range"
    1227, // "{!inningnr} innings overs 0 to {overnr} - Home Team run range"
    1228, // "{!inningnr} innings overs 0 to {overnr} - Away Team run range"
    1229, // "{!inningnr} innings overs 0 to {overnr} - Home Team total"
    1230, // "{!inningnr} innings overs 0 to {overnr} - Away Team total"
    1234, // "Player To Score 1st Touchdown (incl. Overtime)"
    1235, // "Player Touchdowns (incl. Overtime)"
    1236, // "First Point Scorer (incl. Overtime)"
    1237, // "Double Double (incl. Overtime)"
    1238, // "Triple Double (incl. Overtime)"
    1242, // "Race to home {homepoints} and away {awaypoints} points"
    1243, // "Anytime exact score {homepoints}:{awaypoints}"


    1283, // "Booking handicap"

    1287, // "Home Team total breaks"
    1288, // "Away Team total breaks"
    1289, // "Home Team total aces"
    1290, // "Away Team total aces"
    1291, // "Most aces"


    1301, // "{%player} total assists (incl. overtime)"
    1302, // "{%player} total rebounds (incl. overtime)"
    1303, // "{%player} total 3-point field goals (incl. overtime)"

    1308, // "2 minutes - {points} point score draw no bet from {from} to {to} remaining"
    1309, // "4 minutes - {points} point score draw no bet from {from} to {to} remaining"
    1310, // "2 minutes - draw no bet from {from} to {to} remaining"
    1311, // "4 minutes - draw no bet from {from} to {to} remaining"
    1312, // "{!possessionnr} possession outcome"
]

//------------------------------------------------------------------------------

export let MainMarket = {
    name: "mainMarket",
    name_kor: "메인 마켓",
    data: MainMarketData
}

export const HalfData = [
    46, // "Halftime/fulltime correct score"
    47, // "Halftime/fulltime"
    48, // "Home Team to win both halves"
    49, // "Away Team to win both halves"
    50, // "Home Team to win either half"
    51, // "Away Team to win either half"
    52, // "Highest scoring half"
    53, // "Home Team highest scoring half"
    54, // "Away Team highest scoring half"
    55, // "1st/2nd half both teams to score"
    56, // "Home Team to score in both halves"
    57, // "Away Team to score in both halves"
    58, // "Both halves over {total}"
    59, // "Both halves under {total}"
    60, // "1st half - 1x2"
    61, // "1st half - which team wins the rest"
    62, // "1st half - {!goalnr} goal"
    63, // "1st half - double chance"
    64, // "1st half - draw no bet"
    65, // "1st half - handicap {hcp}"
    66, // "1st half - handicap"
    68, // "1st half - total"
    69, // "1st half - Home Team total"
    70, // "1st half - Away Team total"
    71, // "1st half - exact goals"
    72, // "1st half - Home Team exact goals"
    73, // "1st half - Away Team exact goals"
    74, // "1st half - odd/even"
    75, // "1st half - both teams to score"
    76, // "1st half - Home Team clean sheet"
    77, // "1st half - Away Team clean sheet"
    78, // "1st half - 1x2 & both teams to score"
    79, // "1st half - 1x2 & total"
    80, // "1st half - correct score [{score}]"
    81, // "1st half - correct score"
    83, // "2nd half - 1x2"
    84, // "2nd half - {!goalnr} goal"
    85, // "2nd half - double chance"
    86, // "2nd half - draw no bet"
    87, // "2nd half - handicap {hcp}"
    88, // "2nd half - handicap"
    90, // "2nd half - total"
    91, // "2nd half - Home Team total"
    92, // "2nd half - Away Team total"
    93, // "2nd half - exact goals"
    94, // "2nd half - odd/even"
    95, // "2nd half - both teams to score"
    96, // "2nd half - Home Team clean sheet"
    97, // "2nd half - Away Team clean sheet"
    98, // "2nd half - correct score"


    119, // "Overtime 1st half - 1x2"
    120, // "Overtime 1st half - handicap"
    121, // "Overtime 1st half - correct score [{score}]"


    149, // "1st half - booking 1x2"
    150, // "1st half - {!bookingnr} booking"
    151, // "1st half - total booking points"
    152, // "1st half - total bookings"
    153, // "1st half - Home Team total bookings"
    154, // "1st half - Away Team total bookings"
    155, // "1st half - exact bookings"
    156, // "1st half - Home Team exact bookings"
    157, // "1st half - Away Team exact bookings"
    158, // "1st half - booking point range"
    159, // "1st half - sending off"
    160, // "1st half - Home Team sending off"
    161, // "1st half - Away Team sending off"


    173, // "1st half - corner 1x2"
    174, // "1st half - {!cornernr} corner"
    175, // "1st half - last corner"
    176, // "1st half - corner handicap"
    177, // "1st half - total corners"
    178, // "1st half - Home Team total corners"
    179, // "1st half - Away Team total corners"
    180, // "1st half - Home Team exact corners"
    181, // "1st half - Away Team exact corners"
    182, // "1st half - corner range"
    183, // "1st half - odd/even corners"

    231, // "2nd half - handicap (incl. overtime)"
    232, // "2nd half - total (incl. overtime)"

    293, // "2nd half - 1x2 (incl. overtime)"
    294, // "2nd half - draw no bet (incl. overtime)"
    295, // "2nd half - odd/even (incl. overtime)"

    470, // "1st half - winning margin"

    540, // "Double chance (match) & 1st half both teams score"
    541, // "Double chance (match) & 2nd half both teams score"
    542, // "1st half - double chance & both teams to score"
    543, // "2nd half - 1x2 & both teams to score"
    544, // "2nd half - 1x2 & total"
    545, // "2nd half - double chance & both teams to score"


    552, // "1st half - multigoals"
    553, // "2nd half - multigoals"
    602, // "1st half - race to {cornernr} corners"
    618, // "1st half - Home Team odd/even"
    619, // "1st half - Away Team odd/even"
    736, // ""
    818, // "Halftime/fulltime & total"
    819, // "Halftime/fulltime & 1st half total"
    820, // "Halftime/fulltime & exact goals"
    905, // "1st half - next score"

    1177, // "1st half 1x2 & 1st half total"
    1178, // "1st half handicap & 1st half total"
    1179, // "1st Half Result or Match Result"
    
    1284, // "Overtime 1st half - total"

    1305, // "1st half - {points} point score draw no bet"
    1306, // "2nd half - {points} point score draw no bet"
]

export const Half = {
    name: "1st Half/2nd Half",
    name_kor: "전반전/후반전",
    data: HalfData
}

export const PeriodData = [
    426, // "{!periodnr} period 1x2 & winner (incl. overtime and penalties)"
    429, // "{!periodnr} period 1x2 & 1x2"
    432, // "Highest scoring period"
    433, // "Home Team highest scoring period"
    434, // "Away Team highest scoring period"
    435, // "Home Team to win all periods"
    436, // "Away Team to win all periods"
    437, // "Home Team to win any period"
    438, // "Away Team to win any period"
    439, // "Home Team to score in all periods"
    440, // "Away Team to score in all periods"
    441, // "All periods over {total}"
    442, // "All periods under {total}"
    443, // "{!periodnr} period - 1x2"
    444, // "{!periodnr} period - {!goalnr} goal"
    445, // "{!periodnr} period - handicap {hcp}"
    446, // "{!periodnr} period - total"
    447, // "{!periodnr} period - Home Team total"
    448, // "{!periodnr} period - Away Team total"
    449, // "{!periodnr} period - exact goals"
    450, // "{!periodnr} period - Home Team exact goals"
    451, // "{!periodnr} period - Away Team exact goals"
    452, // "{!periodnr} period - both teams to score"
    453, // "{!periodnr} period - which team to score"
    454, // "{!periodnr} period - Home Team clean sheet"
    455, // "{!periodnr} period - Away Team clean sheet"
    456, // "{!periodnr} period - correct score"
    457, // "{!periodnr} period - last team to score"
    458, // "{!periodnr} period - which team wins the rest"
    459, // "{!periodnr} period - draw no bet"
    460, // "{!periodnr} period - handicap"
    462, // "{!periodnr} period - odd/even"
    
    529, // "{!periodnr} period - double chance"
]

export const Period = {
    name: "Period",
    name_kor: "피리어드별",
    data: PeriodData
}

export const QuarterData = [
    234, // "Highest scoring quarter"
    235, // "{!quarternr} quarter - 1x2"
    236, // "{!quarternr} quarter - total"

    301, // "{!quarternr} quarter - winning margin"
    302, // "{!quarternr} quarter - draw no bet"
    303, // "{!quarternr} quarter - handicap"
    304, // "{!quarternr} quarter - odd/even"
    305, // "{!quarternr} quarter - race to {pointnr} points"

    609, // "Team with highest scoring quarter"

    611, // "{!quarternr} quarter - 1x2 (incl. overtime)"

    613, // "{!quarternr} quarter - draw no bet (incl. overtime)"
    614, // "{!quarternr} quarter - handicap (incl. overtime)"
    615, // "{!quarternr} quarter - total (incl. overtime)"

    756, // "{!quarternr} quarter - Home Team total"
    757, // "{!quarternr} quarter - Away Team total"

    960, // "{!quarternr} quarter - last point"

    1057, // "{!quarternr} quarter - race to {pointnr} points"

    1090, // "{!quarternr} quarter - {!pointnr} point"

    1175, // "1st quarter 1x2 & 1st quarter total"
    1176, // "1st quarter handicap & 1st quarter total"
    
    1307, // "{!quarternr} quarter - {points} point score draw no bet"
]

export const Quarter = {
    name: "Quarter",
    name_kor: "쿼터별",
    data: QuarterData
}

export const InningData = [
    268, // "Will there be an extra inning"
    269, // "Home Team to bat in 9th inning"
    270, // "Team to win more innings"
    271, // "Team with highest scoring inning"
    272, // "Highest scoring inning"
    273, // "Exact runs in highest scoring inning"

    287, // "{!inningnr} inning - 1x2"
    288, // "{!inningnr} inning - total"

    746, // "{!inningnr} inning - handicap"
    747, // "{!inningnr} inning - Home Team total"
    748, // "{!inningnr} inning - Away Team total"
    749, // "{!inningnr} inning - Home Team to score"
    750, // "{!inningnr} inning - Away Team to score"
    751, // "{!inningnr} inning - both teams to score"

    1043, // "{!inningnr} inning - total hits"
    1044, // "{!inningnr} inning - Home Team total hits"
    1045, // "{!inningnr} inning - Away Team total hits"
    
    1070, // "{!inningnr} inning - most strikes"
    1071, // "{!inningnr} inning - most balls"
    1072, // "{!inningnr} inning - most hits"
    1073, // "{!inningnr} inning - exact home runs"
    1074, // "{!inningnr} inning - Home Team exact home runs"
    1075, // "{!inningnr} inning - Away Team exact home runs"
    1076, // "{!inningnr} inning - total pitches"
    1077, // "{!inningnr} inning - Home Team total pitches"
    1078, // "{!inningnr} inning - Away Team total pitches"
    1079, // "{!inningnr} inning - Home Team exact strikeouts"
    1080, // "{!inningnr} inning - Away Team exact strikeouts"
    1081, // "{!inningnr} inning - Home Team to record a double or triple play"
    1082, // "{!inningnr} inning - Away Team to record a double or triple play"
    
    1123, // "{!inningnr} inning - Winner"
]

export const Inning = {
    name: "Inning",
    name_kor: "이닝별",
    data: InningData
}

export const SetData = [
    188, // "Set handicap"

    203, // "{!setnr} set - game handicap"
    
    192, // "Home Team to win a set"
    193, // "Away Team to win a set"
    194, // "Any set to nil"

    196, // "Exact sets"

    201, // "Double result (1st set/match)"
    202, // "{!setnr} set - winner"

    204, // "{!setnr} set - total games"
    205, // "{!setnr} set - odd/even games"
    206, // "{!setnr} set - will there be a tiebreak"
    207, // "{!setnr} set - correct score"
    208, // "{!setnr} set - race to {games} games"
    
    210, // "{!setnr} set game {gamenr} - winner"
    211, // "{!setnr} set game {gamenr} - exact points"
    212, // "{!setnr} set game {gamenr} - to deuce"
    213, // "{!setnr} set game {gamenr} - odd/even points"
    214, // "{!setnr} set game {gamenr} - correct score"
    215, // "{!setnr} set game {gamenr} - correct score or break"
    216, // "{!setnr} set game {gamenr} - race to {pointnr} points"
    217, // "{!setnr} set game {gamenr} - first {pointnr} points winner"
    218, // "{!setnr} set game {gamenr} - {!pointnr} point"

    306, // "How many sets will be decided by extra points"

    309, // "{!setnr} set - point handicap"
    310, // "{!setnr} set - total points"
    311, // "{!setnr} set - odd/even"
    312, // "{!setnr} set - {!pointnr} point"
    313, // "{!setnr} set - race to {pointnr} points"
    314, // "Total sets"
    
    525, // "Will there be a 4th set"
    526, // "Will there be a 5th set"

    850, // "Home Team to win exactly 1 set"
    851, // "Away Team to win exactly 1 set"
    852, // "Home Team to win exactly 2 sets"
    853, // "Away Team to win exactly 2 sets"

    894, // "{!setnr} set tiebreak - correct score"
    895, // "{!setnr} set tiebreak - total points"
    
    1056, // "{!setnr} set - winner & total"

    1209, // "{!setnr} set - exact score group"
    
    1269, // "{!setnr} set game {gamenr} - ace"
    1270, // "{!setnr} set - {!acenr} ace"
    1271, // "{!setnr} set - Home Team total points"
    1272, // "{!setnr} set - Away Team total points"
    1273, // "{!setnr} set - Away Team total breaks"
    1274, // "{!setnr} set - Home Team total aces"
    1275, // "{!setnr} set - Away Team total aces"
    1276, // "{!setnr} set - most aces"
    1277, // "{!setnr} set - Home Team total breaks"
    1278, // "Both players to win a set"
    1279, // "{!setnr} set - correct score after 4 games"
    1280, // "{!setnr} set - correct score after 6 games"
    1281, // "{!setnr} set - {!breaknr} break"
    1282, // "{!setnr} set game {gamenr} - break point"
    
    1292, // "{!setnr} set game {gamenr} - {!pointnr} point serve outcome"
    1293, // "{!setnr} set game {gamenr} - {!pointnr} point outcome"
    1294, // "{!setnr} set game {gamenr} - {!pointnr} point total shots"
    1295, // "{!setnr} set game {gamenr} - {!pointnr} point last stroke"
]

export const Set = {
    name: "Set",
    name_kor: "세트별",
    data: SetData
}

export const ExtraData = [
    41, // "Correct score [{score}]"

    45, // "Correct score"

    118, // "Overtime - correct score [{score}]"

    135, // "Penalty shootout - correct score"
    
    199, // "Correct score"


    247, // "{!gamenr} game - total points"

    427, // "Correct score (incl. overtime and penalties)"

    430, // "Correct score [{score}]"
    431, // "Correct score"
    
    889, // "Anytime goalscorer & correct score"
    890, // "{!goalnr} goalscorer & correct score"
    
    897, // "Overtime - correct score"
    
    921, // "{%player} total points (incl. overtime)"
    
    1285, // "Home Team total points"
    1286, // "Away Team total points"
    
    1300, // "{%player} total points (incl. overtime)"
    
    1304, // "{%player} total points + rebounds + assists (incl. overtime)"
]

export const Extra = {
    name: "extra",
    name_kor: "추가옵션",
    data: ExtraData
}





export const esportsmain = MainMarketData.concat(PeriodData, QuarterData, InningData, SetData, HalfData, ExtraData);


export const esports1game = [
]

export const esports2game = [
]

export const esports3game = [
]

export const EsportsMainMarkets = [
    esportsmain,
    // esports1game,
    // esports2game,
    // esports3game
]




export const AllMarket = {
    name: "allMarket",
    name_kor: "전체",
    // data: MainMarketData.concat(HalfData, PeriodData, QuarterData, InningData, SetData, ExtraData)
    data: []
}


export const EsportsMain = {
    name: "mainMarket",
    name_kor: "메인 마켓",
    data: esportsmain
}

export const Dota1 = {
    name: "game1",
    name_kor: "1게임",
    data: esports1game
}

export const Dota2 = {
    name: "game2",
    name_kor: "2게임",
    data: esports2game
}

export const Dota3 = {
    name: "game3",
    name_kor: "3게임",
    data: esports3game
}


export const betRadarDotaMarkets = [
    AllMarket,
    EsportsMain,
    Dota1,
    Dota2,
    Dota3
]


export const betRadarLeagueOfLegendsaMarkets = [
    AllMarket,
    EsportsMain,
    Dota1,
]




export const betRadarsoccerProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, QuarterData, InningData, SetData)
    },
    Half,
    Extra,
]

export const betRadarIceHockeylProvidedMarketIds = [

    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, QuarterData, InningData, SetData, HalfData, ExtraData)
    },
    Period,
    Extra,
]

export const betRadarbasketballProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, InningData, SetData, HalfData, ExtraData)
    },
    Quarter,
]

export const betRadarfootballProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, InningData, SetData, HalfData)
    },
    Quarter,
    Extra
]

export const betRadarbaseballProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, QuarterData, SetData, HalfData)
    },
    Inning,
    Extra
]

export const betRadarvolleyballProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, QuarterData, InningData, HalfData)
    },
    Set,
    Extra
]

export const betRadarMMAProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, QuarterData, InningData, SetData, HalfData, ExtraData)
    },
]

export const betRadarDefaultProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, QuarterData, InningData, SetData, HalfData, ExtraData, HalfData)
    },
    Extra
]

export const betRadarDefaultEsportsMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: esportsmain.concat(esports1game, esports2game, esports3game)
    },
]


// WEBPACK FOOTER //
// ./src/utils/betRadarGroup.js